import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    OrderWidget: {
        background: '#f5f6fa',
        minWidth:'362px',
        width: "60vw",
        height: '95vh',
        '& .Btn--Primary': {
            "background": "#6E7187",
            "boxShadow": "0px 10px 30px rgba(0, 0, 0, 0.07), 0px 4px 18px rgba(249, 98, 83, 0.25)",
            "borderRadius": "8px",
            "fontWeight": "700",
            "fontSize": "12px",
            "lineHeight": "15px",
            "textAlign": "center",
            "textTransform": "uppercase",
            "color": "#FFFFFF",
            // boxShadow: 'none',
            border: 'none',
            padding: '16px',
            display: 'block',
            width: '100%'
        },
        '& .Btn--Secondary': {
            "background": "#e14954",
            "boxShadow": "0px 10px 30px rgba(0, 0, 0, 0.07), 0px 4px 18px rgba(249, 98, 83, 0.25)",
            "borderRadius": "8px",
            "fontWeight": "700",
            "fontSize": "12px",
            "lineHeight": "15px",
            "textAlign": "center",
            "textTransform": "uppercase",
            "color": "#FFFFFF",
            // boxShadow: 'none',
            border: 'none',
            padding: '16px',
            display: 'block',
            width: '100%'
        }
    },
    TableDetails: {
        "background": "#FFFFFF",
        "border": "1px solid #e5e9f2",
        padding: '10px',
        display: 'flex',
        '& .TableIcon': {
            "width": "32px",
            "height": "32px",
            "left": "696px",
            "top": "31px",
            "background": "#e14954",
            "borderRadius": "8px",
            marginRight: '12px'
        },
        '& .TableName': {
            marginRight: 'auto',
            '&>div:first-child': {
                "fontStyle": "normal",
                "fontWeight": "700",
                "fontSize": "12px",
                "lineHeight": "15px",
                "textTransform": "uppercase",
                "color": "#271D1C",
                marginBottom: '5px'
            },
            '&>div:last-child': {
                "fontWeight": "700",
                "fontSize": "8px",
                "lineHeight": "10px",
                "textTransform": "uppercase",
                "color": "rgba(39, 29, 28, 0.75)"
            }
        },
        '& .Actions': {
            color: '#6E7187',
            fontSize: '20px'
        }
    },
    CustomerDetails: {
        "background": "#FFFFFF",
        "border": "1px solid #e5e9f2",
        padding: '10px',
        display: 'flex',
        '& .TableIcon': {
            "width": "32px",
            "height": "32px",
            "left": "696px",
            "top": "31px",
            "background": "#e14954",
            "borderRadius": "8px",
            marginRight: '12px'
        },
        '& .CustomerName': {
            display: 'flex',
            alignItems: 'center',
            marginRight: 'auto',
            '& > div:first-child': {
                fontStyle: 'normal',
                fontWeight: 'bold',
                fontSize: '14px', // Increase the font size
                lineHeight: '15px',
                textTransform: 'uppercase',
                color: '#271D1C',
                marginLeft: '5px', // Add a small margin from the left
            },
            '& > div:last-child': {
                fontWeight: 'bold',
                fontSize: '10px', // Increase the font size
                lineHeight: '10px',
                textTransform: 'uppercase',
                color: 'rgba(39, 29, 28, 0.75)',
                marginLeft: '5px', // Add a small margin from the left
            },
        },
        '& .Actions': {
            color: '#6E7187',
            fontSize: '20px',
        },
    },
    OrdersNav: {
        height: '70px',
        whiteSpace: 'nowrap',
        borderSpacing: '8px',
        '& a': {
            marginRight: '5px'
        },
    },
    OrderItems: {
        "background": "rgba(251, 253, 245, 0.75)",
        "borderRadius": "8px 8px 0 0",
        height: "42vh",
        padding: '15px',
        width: '100%',
        overflowY: 'scroll',
        position: 'relative',
        '& .Item': {
            padding: '4px',
            width: '100%',
            "borderRadius": "8px",
            transition: '0.3s all',
            cursor: 'pointer',
            '&.IsSelected': {
                "background": "#FFFFFF",
            },
            '& .Item__Main': {
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                '& .PreActions': {
                    marginRight: '8px'
                },
                '& .Content': {
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    '& .Img': {
                        marginRight: '4px',
                        "borderRadius": "8px",
                        overflow: 'hidden',
                        '& img': {
                            overflow: 'hidden'
                        }
                    },
                    '& .Name': {
                        display: 'grid',
                        gridTemplateColumns: '1fr',
                        gridTemplateRows: 'auto auto',
                        gap: '5px',
                        '&>div:first-child': {
                            fontStyle: 'normal',
                            fontWeight: 'bold',
                            marginRight: '10px',
                            fontSize: '14px',
                            // "marginRight": '10px',
                            // "fontSize": "12px",
                            "lineHeight": "15px",
                            "textTransform": "uppercase",
                            "color": "#271D1C"
                        },
                        '&>div:last-child': {
                            "fontStyle": "normal",
                            "fontWeight": "400",
                            "fontSize": "10px",
                            "lineHeight": "12px",
                            "textTransform": "uppercase",
                            "color": "#6E7187"
                        }
                    },
                    '& .Price': {
                        "fontStyle": "normal",
                        "fontWeight": "400",
                        "fontSize": "12px",
                        "lineHeight": "15px",
                        "textAlign": "right",
                        "textTransform": "uppercase",
                        "color": "#271D1C",
                        "marginLeft": 'auto'
                    },
                },
                '& .Content_right': {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    '& .Img': {
                        marginRight: '4px',
                        "borderRadius": "8px",
                        overflow: 'hidden',
                        '& img': {
                            overflow: 'hidden'
                        }
                    },
                    '& .Name': {
                        '&>div:first-child': {
                            "fontStyle": "normal",
                            "fontWeight": "400",
                            "marginRight": '10px',
                            "fontSize": "12px",
                            "lineHeight": "15px",
                            "textTransform": "uppercase",
                            "color": "#271D1C"
                        },
                        '&>div:last-child': {
                            "fontStyle": "normal",
                            "fontWeight": "400",
                            "fontSize": "10px",
                            "lineHeight": "12px",
                            "textTransform": "uppercase",
                            "color": "#6E7187"
                        }
                    },
                    '& .Price': {
                        "fontStyle": "normal",
                        "fontWeight": "400",
                        "fontSize": "12px",
                        "lineHeight": "15px",
                        "textAlign": "right",
                        "textTransform": "uppercase",
                        "color": "#271D1C",
                        "marginLeft": 'auto'
                    },
                },
                '& .PostActions': {
                    marginLeft: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    '& .BtnToggle': {
                        "background": "#e5e9f2",
                        "borderRadius": "2px",
                        "width": "15px",
                        "height": "15px",
                        color: '#271D1C',
                        "fontSize": "15px",
                        "lineHeight": "15px"
                    },
                    '& .PricePoint': {
                        "fontStyle": "normal",
                        "fontWeight": "400",
                        "fontSize": "12px",
                        "lineHeight": "15px",
                        "textAlign": "right",
                        "textTransform": "uppercase",
                        "color": "#271D1C",
                        marginRight: 'auto',
                    }
                },

            },
            '& .Item__Secondary': {
                '&>div': {
                    display: 'flex',
                    alignItems: 'center',
                    '&>span:first-child': {
                        "fontStyle": "normal",
                        "fontWeight": "400",
                        "fontSize": "10px",
                        "lineHeight": "12px",
                        "color": "#271D1C",
                        marginRight: 'auto',

                    },
                    '&>span:last-child': {
                        "fontStyle": "normal",
                        "fontWeight": "500",
                        "fontSize": "10px",
                        "lineHeight": "12px",
                        "textAlign": "right",
                        "textTransform": "uppercase",
                        "color": "#271D1C"
                    }
                }
            },
            '& .PostActions': {
                display: 'flex',
                justifyContent: 'flex-end',
                '& .BtnToggle': {
                    "background": "#e5e9f2",
                    "borderRadius": "2px",
                    "width": "15px",
                    "height": "15px",
                    color: '#271D1C',
                    "fontSize": "15px",
                    "lineHeight": "15px"
                }
            },
        },'& .Item_2': {
            padding: '4px',
            width: '60%',
            "borderRadius": "8px",
            transition: '0.3s all',
            cursor: 'pointer',
            '&.IsSelected': {
                "background": "#FFFFFF",
            },
            '& .Item__Secondary': {
                '&>div': {
                    display: 'flex',
                    alignItems: 'center',
                    '&>span:first-child': {
                        "fontStyle": "normal",
                        "fontWeight": "400",
                        "fontSize": "8px",   /* Smaller font size */
                        "lineHeight": "10px", /* Smaller line height */
                        "color": "#271D1C",
                        marginRight: 'auto',
                    },
                    '&>span:last-child': {
                        "fontStyle": "normal",
                        "fontWeight": "500",
                        "fontSize": "8px",   /* Smaller font size */
                        "lineHeight": "10px", /* Smaller line height */
                        "textAlign": "right",
                        "textTransform": "uppercase",
                        "color": "#271D1C"
                    }
                }
            },
            '& .PostActions': {
                display: 'flex',
                justifyContent: 'flex-end',
                "fontSize": "12px",   /* Smaller font size */
                "lineHeight": "12px",
                '& .BtnToggle': {
                    "background": "#e5e9f2",
                    "borderRadius": "2px",
                    "width": "15px",
                    "height": "15px",
                    color: '#271D1C',
                    "fontSize": "2px",   /* Smaller font size */
                    "lineHeight": "2px"  /* Smaller line height */
                }
            }
        },
    },
    Pricing: {
        padding: '15px',
        "background": "rgba(251, 253, 245, 0.75)",
        "borderRadius": " 0 0 8px 8px",
        marginBottom: '10px',
        '& .Pricing__Components': {
            borderTop: '0.75px solid #e5e9f2',
            paddingTop: '10px',
            '&>div': {
                display: 'flex',
                alignItems: 'center',
                marginBottom: '8px',
                '&>span:first-child': {
                    "fontStyle": "normal",
                    "fontWeight": "400",
                    "fontSize": "12px",
                    "lineHeight": "15px",
                    "textTransform": "uppercase",
                    "color": "#271D1C",
                    marginRight: 'auto'

                },
                '&>span:last-child': {
                    "fontStyle": "normal",
                    "fontWeight": "400",
                    "fontSize": "12px",
                    "lineHeight": "15px",
                    "textAlign": "right",
                    "textTransform": "uppercase",
                    "color": "#271D1C"
                }
            }
        },
        '& .Pricing__Total': {
            borderTop: '0.75px solid #e5e9f2',
            paddingTop: '10px',
            '&>div': {
                display: 'flex',
                alignItems: 'center',
                '&>span:first-child': {
                    "fontStyle": "normal",
                    "fontWeight": "700",
                    "fontSize": "14px",
                    "lineHeight": "17px",
                    "textTransform": "uppercase",
                    "color": "#271D1C",
                    marginRight: 'auto'

                },
                '&>span:last-child': {
                    "fontStyle": "normal",
                    "fontWeight": "700",
                    "fontSize": "14px",
                    "lineHeight": "17px",
                    "textAlign": "right",
                    "textTransform": "uppercase",
                    "color": "#271D1C"
                }
            }
        }
    },
    Actions: {
        '& button': {
            marginBottom: '8px'
        },
        '& button:hover': {
            cursor: 'pointer'
        }
    },
    Accordion: {
        // Add your custom styles for the accordion container here
        // Example: backgroundColor: 'red',
        "background": "rgba(251, 253, 245, 0.75)",
        "borderRadius": "0px 0px 0 0",
        padding: '0px',
        expandIcon: {
            color: 'red', // Customize the color of the expand/collapse icon
            // Add any other desired styles for the expand/collapse icon
        },
        boxShadow: 'none', // this styles directly apply to accordion
        border: `0px solid gray`,
        '.MuiAccordionDetails-root': {},
        '.MuiAccordionSummary-root': {},
        '&$expanded': {
            marginBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
    },
    AccordionSummary: {
        // Add your custom styles for the accordion container here
        // Example: backgroundColor: 'red',
        "flex-direction": "row-reverse",
        display: 'flex',
        // "justifyContent": 'flex-start', // Align items to the left
        "background": "transparent",
        "borderRadius": "0px 0px 0 0",
        padding: '0px',
        boxShadow: 'none', // this styles directly apply to accordion
        border: `0px solid gray`,
        marginRight: 'auto',
        '.MuiAccordionDetails-root': {},
        '.MuiAccordionSummary-root': {},
        '&$expanded': {
            marginBottom: 0,
        },
        "&.Mui-expanded": {
            minHeight: 0
        },
        "& .MuiAccordionSummary-content.Mui-expanded": {
            // margin from https://github.com/mui-org/material-ui/blob/cc0e2ab63e8be9ec4d51a49bfde17ef28fc77b9c/packages/mui-material/src/AccordionSummary/AccordionSummary.js#L64-L64
            margin: "0px 0px 0 0"
        },
        expandIcon: {
            marginRight: 'auto', // Align the icon to the right
        },
    },

    Table_ReservedWrap: {
        textAlign: 'center',
        "width": "32px",
        "height": "32px",
        "left": "696px",
        "top": "31px",
        "background": "#B12AE0",
        "borderRadius": "8px",
        marginRight: '12px',
        '& img': {
            display: 'inline'
        },
    },
    Table_edit_customer: {
        textAlign: 'center',
        "width": "23px",
        "height": "23px",
        "background": "#e14954",
        "borderRadius": "8px",
        // marginRight: '12px',
        '& img': {
            display: 'inline'
        },
    },
    Table_edit_order_right: {
        // display: 'flex',
        // justifyContent: 'flex-end',  // Aligns the content to the right
        // alignItems: 'center',
        textAlign: 'center',
        "width": "25px",
        "height": "25px",
        "background": "#e14954",
        "borderRadius": "8px",
        // marginRight: '12px',
        '& img': {
            display: 'inline'
        },
    },
    Arrow_enabled: {
        textAlign: 'center',
        "width": "20px",
        "height": "20px",
        "background": "#e14954",
        "borderRadius": "8px",
        '& img': {
            display: 'inline'
        },
    },
    Arrow_disabled: {
        textAlign: 'center',
        "width": "20px",
        "height": "20px",
        "background": "#e5e9f2",
        "borderRadius": "8px",
        '& img': {
            display: 'inline'
        },
    }
}));
